import React from 'react';
import { InlineWidget } from "react-calendly";

function About() {
  return (
    <div className="app">
      <div className="container">
        <main className="main-content">

          {/* About Section */}
          <section className="intro">
            <h2 className="section-subtitle">About Me</h2>
            <p className="section-text">Data & Analytics leader with expertise in BI, data science, and cloud platforms. Proven ability to deliver
business insights through complex projects, ML, and data analytics. Skilled in optimising data workflows,
implementing ML solutions, and leading and strategising complex projects to deliver actionable business
insights. Proven ability to mentor analysts and build scalable data solutions.</p>
              {/* <p className="section-text">Hi there!</p>
              <p className="section-text">I'm Jessy Wang, the founder of Insio, an AI-powered insurance platform designed to simplify property buying, renting, and investing. With a background in data science, machine learning, insurance, risk management, and investment, I specialise in leading projects, developing analytical models, and driving strategic success.</p>
              <br></br>
              <p className="section-text">I have extensive experience mentoring teams and leveraging technologies like Python, SQL, Tableau, Power BI, AWS, GCP, and Databricks to deliver impactful solutions. My passion lies in innovation and using data-driven insights to solve complex problems.</p>
              <br></br>
              <p className="section-text">Currently, I’m working on <a className="apple-link" href="YOUR_LINK_HERE" target="_blank">Insio</a>, an intelligent AI-powered insurance platform that simplifies home buying, renting and investing. Whether you're an investor, an agent, or an individual looking for a seamless property experience, <b>Insio</b> is here to make your journey smarter and hassle-free.</p>
              <br></br>
              <p className="section-text">At Insio, our mission is to revolutionise the insurance industry by making property decisions smarter, faster, and hassle-free. Whether you're an investor, an agent, or an individual looking for your dream home, we’re building the best platform to support you.</p>
              <br></br>
              <p className="section-text">Feel free to explore <a className="apple-link" href="YOUR_LINK_HERE" target="_blank">Insio</a>, and if you're interested in insurance, AI, or start-ups, I’d love to connect. You can book a time with me through my calendar below—just leave a brief note on what you’d like to chat about. Looking forward to speaking with you!</p> */}
          </section>

          {/* Who Am I Section */}
          <section className="features">
            <h2 className="section-title">Who Am I?</h2>
            <ul className="contents-list">
              {["An Entrepreneur", "A Wanderlust", "A Tennis Player", "A Foodie", "Dog Lover!"].map((item, index) => (
                <li key={index} className="feature-item">
                  <span className="bullet-point">•</span> {item}
                </li>
              ))}
            </ul>
          </section>
        </main>
      </div>
    </div>
  );
}

export default About;
